module.exports = __webpack_public_path__ + "img/application_bg4_m.49889f1e.jpg";